import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  setCurrentPage,
  setVideoSearchInput,
} from '@assetManagement/store/uploadVideo';
import { videoSearchInputSelector } from '@assetManagement/selectors/uploadVideo';
import Input from 'components/Input';
import styles from './UploadedVideosSearch.module.scss';

const MIN_KEYWORD_LENGTH = 3;

export default function UploadedVideosSearch({ className }) {
  const dispatch = useDispatch();
  const videoSearchInput = useSelector(videoSearchInputSelector);

  const handleSearchQueryChange = useCallback(
    (event) => {
      dispatch(setVideoSearchInput(event.target.value));
      dispatch(setCurrentPage(1));
    },
    [dispatch]
  );

  return (
    <Input
      className={classNames(className, styles.input)}
      onChange={handleSearchQueryChange}
      value={videoSearchInput}
      placeholder={`Enter Video Name (Type atleast ${MIN_KEYWORD_LENGTH} 
characters to search)`}
    />
  );
}
